exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-slot[data-v-2e646be0] {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-end;\r\n    height: 38vh;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n    background: repeat url(/images/background-wpp.png) #e6ded5;\r\n    background-size: 80%;\r\n    background-blend-mode: soft-light;\n}\n.template-preview[data-v-2e646be0] {\r\n    width: 60%;\r\n    align-self: flex-start;\r\n    text-align: start;\r\n    margin: 10px;\r\n    background-color: white;\r\n    padding: 5px;\r\n    border-radius: 5px;\n}\r\n", ""]);

// exports
